// src/pages/membersStatusPage/membersStatusPage.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LeftArrow } from "../../components/icons";
import { SolidColorButton } from "../../components/buttons";
import { apiSearchMembersByUsername } from "../../api/backend/user";
import { apiAdminSetMemberStatus } from "../../api/backend/admin";
import "./membersStatusPage.scss";

export default function MembersStatusPage() {
  const navigate = useNavigate();

  const [query, setQuery] = useState("");
  const [searching, setSearching] = useState(false);
  const [savingId, setSavingId] = useState(null);
  const [error, setError] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    console.log("[MembersStatusPage] mounted");
    window.scrollTo(0, 0);
  }, []);

  const runSearch = async () => {
    if (!query.trim()) return;
    setError("");
    setSearching(true);
    try {
      // backend expects a string; it will iLike %query%
      const users = await apiSearchMembersByUsername({
        membersUserName: query.trim(),
      });
      setResults(Array.isArray(users) ? users : []);
    } catch (e) {
      console.error(e);
      setError("Search failed. Try again.");
    } finally {
      setSearching(false);
    }
  };

  const flipStatus = async (u) => {
    const next = u.memberStatus === "suspended" ? "active" : "suspended";
    setSavingId(u.id);
    setError("");
    try {
      await apiAdminSetMemberStatus(u.id, next);
      // optimistic update
      setResults((list) =>
        list.map((x) => (x.id === u.id ? { ...x, memberStatus: next } : x))
      );
    } catch (e) {
      console.error(e);
      setError("Could not update status.");
    } finally {
      setSavingId(null);
    }
  };

  return (
    <div className="admin-member-status-page">
      <div id="topMemberStatusPage" />

      <SolidColorButton
        solidColorBtnImage={
          <LeftArrow
            height="15px"
            width="15px"
            fillColor="#964b00"
            strokeWidth="4"
            strokeColor="#964b00"
          />
        }
        className="gold-btn"
        solidColorBtnText="Back"
        solidColorBtnFontWeight="800"
        solidColorBtnFontFamily="helvetica"
        solidColorBtnTextFontSize=".75rem"
        solidColorBtnFontColor="#964b00"
        solidColorBtnWidth="100px"
        solidColorBtnBoxShadow="0 4px 3px 1px #000000bb, 0 6px 8px #000000bb, 0 -4px 4px #000000bb, 0 -6px 4px #000000bb, inset 0 0 3px 0 #000000bb"
        onClick={() => navigate(-1)}
      />

      <h2 style={{ color: "#ffcf33", margin: "12px 0" }}>
        Admin · Member Status
      </h2>

      {/* simple input + button */}
      <div
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && runSearch()}
          placeholder="Type unique username…"
          style={{
            flex: 1,
            padding: "10px 12px",
            borderRadius: 10,
            border: "1px solid #555",
            background: "#1f1f1f",
            color: "#eee",
          }}
        />
        <button
          onClick={runSearch}
          disabled={searching || !query.trim()}
          style={{
            padding: "10px 14px",
            borderRadius: 10,
            border: "1px solid #555",
            background: "#222",
            color: "#fff",
            cursor: searching || !query.trim() ? "default" : "pointer",
            opacity: searching || !query.trim() ? 0.6 : 1,
          }}
        >
          {searching ? "Searching…" : "Search"}
        </button>
      </div>

      {error && <p className="error">{error}</p>}

      {/* results */}
      <div style={{ marginTop: 12 }}>
        {results.length === 0 && !searching ? (
          <p>No users found</p>
        ) : (
          results.map((u) => {
            const saving = savingId === u.id;
            const next =
              u.memberStatus === "suspended" ? "active" : "suspended";
            return (
              <div
                key={u.id}
                style={{
                  marginBottom: 12,
                  padding: 12,
                  borderRadius: 10,
                  border: "1px solid #555",
                  background: "#1f1f1f",
                }}
              >
                <div
                  style={{
                    marginBottom: 6,
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                  }}
                >
                  {/* avatar if you have profileImageUrl */}
                  {u.profileImageUrl && (
                    <img
                      src={u.profileImageUrl}
                      alt={u.username}
                      style={{ width: 40, height: 40, borderRadius: "50%" }}
                    />
                  )}
                  <div>
                    <div>
                      <strong>@{u.username}</strong>
                    </div>
                    <div style={{ opacity: 0.8 }}>
                      {u.firstName} {u.lastName}
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                  <span
                    style={{
                      textTransform: "uppercase",
                      fontSize: 12,
                      padding: "4px 10px",
                      borderRadius: 999,
                      border: "1px solid #555",
                      background:
                        u.memberStatus === "suspended" ? "#301" : "#103",
                    }}
                  >
                    {u.memberStatus || "unknown"}
                  </span>

                  <button
                    onClick={() => flipStatus(u)}
                    disabled={saving}
                    title={`Change to ${next}`}
                    style={{
                      padding: "6px 10px",
                      borderRadius: 8,
                      border: "1px solid #555",
                      background: "#222",
                      color: "#fff",
                      cursor: saving ? "default" : "pointer",
                      opacity: saving ? 0.6 : 1,
                    }}
                  >
                    {saving ? "Saving…" : `Set ${next}`}
                  </button>

                  <button
                    onClick={() => navigate(`/user-profile/${u.id}`)}
                    style={{
                      padding: "6px 10px",
                      borderRadius: 8,
                      border: "1px solid #555",
                      background: "#222",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                  >
                    View Profile
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
